// Proyectos de Savia.
// status: "curso" = Proyectos en curso | "pasado" = Trayectoria de nuestro equipo.
// Los textos van en `es` y `en`; campos opcionales: si no existen, no se muestran.
// image: foto o logo principal. imageFit: "contain" -> logos/ilustraciones sin recortar.
// logos: logos de socios (PNG con fondo transparente, en public/images/socios/).

const LOGOS = {
  marAzul: { src: '/images/socios/mar-azul.png', name: 'Consultoría Mar Azul' },
  mag: { src: '/images/socios/mag.png', name: { es: 'Ministerio de Agricultura y Ganadería', en: 'Ministry of Agriculture and Livestock' } },
  casaPampa: { src: '/images/socios/casa-pampa.png', name: 'Casa Pampa' },
  cirenas: { src: '/images/socios/cirenas.png', name: 'CIRENAS' },
  fincaLaFe: { src: '/images/socios/finca-la-fe.png', name: { es: 'Finca Experimental La Fe', en: 'La Fe Experimental Farm' } },
  pnud: { src: '/images/socios/pnud.png', name: { es: 'Programa de las Naciones Unidas para el Desarrollo (PNUD)', en: 'United Nations Development Programme (UNDP)' } },
  adiIslaVenado: { src: '/images/socios/adi-isla-venado.png', name: { es: 'Asociación de Desarrollo Integral de Isla Venado', en: 'Isla Venado Integral Development Association' } },
  una: { src: '/images/socios/una.png', name: { es: 'Universidad Nacional de Costa Rica (UNA)', en: 'National University of Costa Rica (UNA)' } },
};

export const projects = [
  // ===================== PROYECTOS EN CURSO =====================
  {
    id: 'curso-1',
    status: 'curso',
    image: '/images/proyectos/isla-venado-recolectores.jpg',
    logos: [LOGOS.pnud, LOGOS.adiIslaVenado, LOGOS.una],
    es: {
      title: 'Manejo adecuado de los materiales valorizables de las islas Venado y Caballo',
      location: 'Golfo de Nicoya',
      tags: ['Gestión de residuos', 'Economía circular', 'Fortalecimiento de capacidades'],
      challenge:
        'Contribuir a la salud pública de los habitantes, a la protección de los ecosistemas marino-costeros y a la conservación de la biodiversidad en las islas Venado y Caballo —reconocidas como patrimonio natural del Estado— mediante el fortalecimiento del modelo comunitario de gestión de residuos sólidos valorizables.',
      partners: 'PNUD, ADI Isla Venado, UNA, instituciones públicas.',
    },
    en: {
      title: 'Proper management of recyclable materials on Venado and Caballo islands',
      location: 'Gulf of Nicoya',
      tags: ['Waste management', 'Circular economy', 'Capacity building'],
      challenge:
        'To contribute to public health, the protection of marine-coastal ecosystems and the conservation of biodiversity on Venado and Caballo islands — recognized as natural heritage of the State — by strengthening the community model for managing recyclable solid waste.',
      partners: 'UNDP, ADI Isla Venado, UNA, public institutions.',
    },
  },
  {
    id: 'curso-2',
    status: 'curso',
    image: '/images/proyectos/sensibilizacion-comunidades.jpg',
    logos: [LOGOS.marAzul],
    es: {
      title: 'Actividades y proyectos de sensibilización y educación ambiental',
      location: 'Orotina de Alajuela, Paraíso de Cartago, Carrillo de Guanacaste',
      tags: ['Recurso hídrico', 'Biodiversidad', 'Gestión de residuos'],
      challenge:
        'Sensibilizar e impulsar la participación de las y los residentes de proyectos habitacionales en acciones de sostenibilidad.',
      partners: 'Empresa Consultoría Mar Azul S.A., sociedad civil.',
    },
    en: {
      title: 'Environmental awareness and education activities and projects',
      location: 'Orotina (Alajuela), Paraíso (Cartago), Carrillo (Guanacaste)',
      tags: ['Water resources', 'Biodiversity', 'Waste management'],
      challenge:
        'To raise awareness among residents of housing developments and encourage them to take part in sustainability actions.',
      partners: 'Consultoría Mar Azul S.A., civil society.',
    },
  },
  {
    id: 'curso-3',
    status: 'curso',
    image: '/images/proyectos/mirs-cobano.png',
    imageFit: 'contain',
    logos: [LOGOS.mag, LOGOS.casaPampa, LOGOS.cirenas, LOGOS.fincaLaFe],
    es: {
      title: 'Comisión de Manejo Integral de Residuos Sólidos',
      location: 'Cóbano, Puntarenas',
      tags: ['Gestión de residuos', 'Gobernanza', 'Economía circular', 'Descarbonización'],
      challenge:
        'Lograr una gestión integral de residuos sólidos en el distrito de Cóbano por medio de la coordinación e interacción de los actores sociales.',
      partners: 'Concejo Municipal de Distrito de Cóbano, Ministerio de Salud, MAG, ADI, ONG, sociedad civil.',
    },
    en: {
      title: 'Integrated Solid Waste Management Commission',
      location: 'Cóbano, Puntarenas',
      tags: ['Waste management', 'Governance', 'Circular economy', 'Decarbonization'],
      challenge:
        'To achieve integrated solid waste management in the district of Cóbano through coordination and interaction among local stakeholders.',
      partners: 'Cóbano District Municipal Council, Ministry of Health, MAG, development associations (ADI), NGOs, civil society.',
    },
  },

  // ===================== TRAYECTORIA DE NUESTRO EQUIPO =====================
  {
    id: 'pasado-1',
    status: 'pasado',
    image: '/images/proyectos/eco-maletas-lanzamiento.jpg',
    links: [
      { label: { es: 'Sitio del proyecto', en: 'Project website' }, url: 'https://ecomaletas.wordpress.com/' },
      { label: 'Video', url: 'https://www.youtube.com/watch?v=3uLf7Mtl5V4' },
    ],
    es: {
      title: 'Eco-Maletas: ecoalfabetización con enfoque lúdico',
      location: 'Coto Brus, Puntarenas',
      tags: ['Biodiversidad y servicios ecosistémicos', 'Contaminación', 'Cambio climático', 'Educación para el desarrollo sostenible'],
      challenge:
        'Facilitar procesos educativos de grupos académicos y comunitarios a través del aporte de herramientas didácticas que fomenten un mayor interés hacia problemas socioambientales y enriquezcan el conocimiento sobre cómo darles solución mediante la adopción de buenos hábitos ambientales.',
      results: [
        '18 escuelas del cantón de Coto Brus con 1 Eco-Maleta como herramienta educativa para las clases de ciencias, estudios sociales, educación cívica, matemáticas y agricultura.',
        'Incremento de la comprensión de estudiantes y profesores sobre ecosistemas, beneficios de los bosques, contaminación y residuos sólidos, y cambio climático.',
        'Aumento de la integración de la OET y las comunidades que rodean la E.B. Las Cruces.',
      ],
      implementation: 'Organización para Estudios Tropicales (OET).',
      partners: 'MEP, Banco Nacional, HB Fuller Foundation.',
    },
    en: {
      title: 'Eco-Maletas: playful eco-literacy',
      location: 'Coto Brus, Puntarenas',
      tags: ['Biodiversity and ecosystem services', 'Pollution', 'Climate change', 'Education for sustainable development'],
      challenge:
        'To support educational processes for school and community groups by providing teaching tools that spark greater interest in socio-environmental problems and deepen understanding of how to solve them through good environmental habits.',
      results: [
        '18 schools in the canton of Coto Brus, each with an Eco-Maleta as a teaching tool for science, social studies, civics, math and agriculture classes.',
        'Students and teachers gained a better understanding of ecosystems, the benefits of forests, pollution and solid waste, and climate change.',
        'Stronger ties between OTS and the communities around Las Cruces school.',
      ],
      implementation: 'Organization for Tropical Studies (OTS).',
      partners: 'MEP, Banco Nacional, HB Fuller Foundation.',
    },
  },
  {
    id: 'pasado-2',
    status: 'pasado',
    image: '/images/proyectos/ocean-friendly-nantipa.jpg',
    links: [
      { label: { es: 'Sitio del proyecto', en: 'Project website' }, url: 'https://www.nicoyawaterkeeper.org/en/ocean-friendly-business' },
      { label: { es: 'Video', en: 'Video' }, url: 'https://www.facebook.com/share/r/1KwoGDxjdk/' },
    ],
    es: {
      title: 'Ocean Friendly Businesses®',
      location: 'Santa Teresa, Cóbano',
      tags: ['Incentivos para la sostenibilidad', 'Certificación', 'Asesoría empresarial'],
      challenge:
        'Acompañar a las empresas en su transición hacia prácticas menos contaminantes, brindándoles educación e incentivos para la adopción de prácticas sostenibles que contribuyan a la salud del océano.',
      results: [
        'Más de 30 comercios hicieron la transición hacia prácticas más sostenibles.',
        '18 comercios certificados como OFB.',
        'Disminución del consumo de plásticos de un solo uso y de productos químicos cosméticos y de limpieza.',
      ],
      implementation: 'Nicoya Peninsula Waterkeeper.',
      partners: 'Municipalidad de Cóbano, Ministerio de Salud, sector comercial.',
    },
    en: {
      title: 'Ocean Friendly Businesses®',
      location: 'Santa Teresa, Cóbano',
      tags: ['Sustainability incentives', 'Certification', 'Business advisory'],
      challenge:
        'To support businesses in their transition toward less polluting practices, providing education and incentives to adopt sustainable practices that contribute to ocean health.',
      results: [
        'More than 30 businesses transitioned to more sustainable practices.',
        '18 businesses certified as OFB.',
        'Lower use of single-use plastics and of chemical cosmetic and cleaning products.',
      ],
      implementation: 'Nicoya Peninsula Waterkeeper.',
      partners: 'Cóbano Municipality, Ministry of Health, local businesses.',
    },
  },
  {
    // El equipo elaboró la guía (producto) para uno de los objetivos; no implementó el proyecto.
    id: 'pasado-3',
    status: 'pasado',
    image: '/images/proyectos/guia-agua-purires.png',
    imageFit: 'contain',
    links: [
      {
        label: { es: 'Ver la guía (PDF)', en: 'View the guide (PDF, Spanish)' },
        url: 'https://drive.google.com/file/d/144HqiTk-Qi_44cpj-vIT71nPjHt5NKBd/view',
      },
    ],
    es: {
      title: 'Guía «Para conservar el agua necesitamos más verdor»',
      location: 'Microcuenca del río Purires, Cartago',
      projectName: 'Diálogo de saberes para la Gestión Integrada del Recurso Hídrico — Microcuenca del río Purires',
      actors: 'Viveros comunitarios · ASADAS',
      challenge:
        'Reducir la vulnerabilidad del recurso hídrico en la microcuenca frente al cambio acelerado del uso del suelo, fortaleciendo la apropiación colectiva de la gestión integrada del agua.',
      results: [
        'Guía educativa de libre reproducción sobre aumento de cobertura vegetal: especies nativas de la zona, priorización de áreas de recarga y bosques ribereños, y prácticas de reforestación y regeneración natural.',
      ],
      implementation: 'ComPurires, UCR, CRUSA.',
    },
    en: {
      title: 'Guide “To conserve water, we need more green”',
      location: 'Purires River micro-watershed, Cartago',
      projectName: 'Knowledge dialogue for Integrated Water Resource Management — Purires River micro-watershed',
      actors: 'Community nurseries · ASADAS (community water associations)',
      challenge:
        'To reduce the vulnerability of water resources in the micro-watershed to rapid land-use change, strengthening collective ownership of integrated water management.',
      results: [
        'A freely reproducible educational guide on increasing vegetation cover: native species of the area, prioritizing recharge areas and riparian forests, and reforestation and natural regeneration practices.',
      ],
      implementation: 'ComPurires, UCR, CRUSA.',
    },
  },
];

// Lista al final de la Trayectoria.
export const otherActivities = {
  es: {
    title: 'Otras actividades realizadas',
    items: [
      'Sala de Educación Ambiental',
      'Detectives de Aves',
      'Capacitaciones para guías de turismo naturalista',
      'Festival Eco-Cultural Las Cruces',
      'Sistemas de captación de aguas pluviales',
    ],
  },
  en: {
    title: 'Other activities',
    items: [
      'Environmental Education Room',
      'Bird Detectives',
      'Training for naturalist tour guides',
      'Las Cruces Eco-Cultural Festival',
      'Rainwater harvesting systems',
    ],
  },
};
